import { useMutation } from '@tanstack/react-query';
import fetchJSON from 'helpers/restApiClient';
import { ISD_CODE, TENANT_ID, PRODUCT_ID } from 'constants/constants';
import urlMapping from 'constants/urlMapping';
import { tokenUtils } from 'utils';

const login = ({ mobile, password }) => {
    const options = {
        method: 'POST',
        headers: {
            platform: 'web',
            'product-id': '1000',
            'tenant-id': TENANT_ID,
        },
        body: {
            admission_number: mobile,
            isd_code: ISD_CODE,
            phone: mobile,
            password,
            product_id: PRODUCT_ID,
            tenant_id: TENANT_ID,
        },
    };

    return fetchJSON(`${urlMapping.login}`, options)
    .then((response) => {
        const { accessToken: token, crnId: userId } = response
        tokenUtils.setToken(token)
        tokenUtils.setUserId(userId)
    })};

export const useAuthentication = () => {
    return useMutation({
        mutationFn: login,
    });
};
